// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2NBbm","footer":"styles_footer__Sc7xF","passCodeTooltip":"styles_passCodeTooltip__2Z9AQ"};